import React, { useEffect } from 'react';
import { Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { loadOrdersAsync } from '../../../redux/feathers/ordersSlice';
import LoadingSpinner from '../../SharedComponents/LoadingSpinner/LoadingSpinner';
import styles from './ManageOrders.module.css';

const ManageOrders = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Load all orders for admin (backend should handle admin role)
    dispatch(loadOrdersAsync({ page: 0, size: 100 }));
  }, [dispatch]);

  const orders = useSelector((state) => state.orders);

  return (
    <section id={styles.manage__orders}>
      <h1>Manage Order</h1>
      {orders.status === 'Pending' ? (
        <LoadingSpinner />
      ) : (
        <>
          {!orders.ordersState.length ? (
            <div className={styles.placeholder__text}>
              <span className={styles.placeholder__image}>
                <svg stroke='currentColor' fill='#027333 ' strokeWidth='0' viewBox='0 0 512 512' height='30px' width='30px' xmlns='http://www.w3.org/2000/svg'>
                  <path d='M454.65 169.4A31.82 31.82 0 00432 160h-64v-16a112 112 0 00-224 0v16H80a32 32 0 00-32 32v216c0 39 33 72 72 72h272a72.22 72.22 0 0050.48-20.55 69.48 69.48 0 0021.52-50.2V192a31.75 31.75 0 00-9.35-22.6zM176 144a80 80 0 01160 0v16H176zm192 96a112 112 0 01-224 0v-16a16 16 0 0132 0v16a80 80 0 00160 0v-16a16 16 0 0132 0z'></path>
                </svg>
              </span>
              <h6>Your Customers Don't Order Any Product</h6>
              <p>Please tell your customers add product to Their Order list.</p>
            </div>
          ) : (
            <>
              <Table bordered size='sm'>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Customer</th>
                    <th>City</th>
                    <th>Total</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.ordersState.map((order, idx) => {
                    const orderId = order.id || order._id;
                    const customerName = order.customer ? `${order.customer.firstName} ${order.customer.lastName}` : order.email || 'N/A';
                    const orderTotal = order.products?.reduce((total, product) => {
                      const productTotal = product.packagingOptions?.reduce((sum, pkg) => {
                        return sum + (pkg.price * pkg.quantityOrder);
                      }, 0) || 0;
                      return total + productTotal;
                    }, 0) || 0;

                    return (
                      <tr key={orderId}>
                        <td>{idx + 1}</td>
                        <td>{customerName}</td>
                        <td>{order.shippingAddress?.city || 'N/A'}</td>
                        <td>${orderTotal.toFixed(2)}</td>
                        <td>
                          <span className={order.status === 'PENDING' ? 'badge bg-warning' : order.status === 'DELIVERED' ? 'badge bg-success' : order.status === 'SHIPPED' ? 'badge bg-primary' : 'badge bg-danger'}>
                            {order.status}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </>
          )}
        </>
      )}
    </section>
  );
};

export default ManageOrders;
